export const TRANSACTION_PAYMENT_TYPE = Object.freeze({
  CASH: "cash",
  CARD: "card",
  CREDIT_CARD: "credit_card",
  DEBIT_CARD: "debit_card",
});
